import React from 'react'
import { ChatInputProps } from '../../interfaces'
import styles from './styles.module.scss'

export const ChatInput: React.FC<ChatInputProps> = ({
    currentMessage,
    setCurrentMessage,
    onSendMessage,
    isLoading,
    placeholder = 'Ask a question about legal matters...',
}) => {
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            onSendMessage()
        }
    }

    return (
        <div className={styles.inputContainer}>
            <textarea
                value={currentMessage}
                onChange={(e) => setCurrentMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={placeholder}
                rows={3}
                disabled={isLoading}
            />
            <button onClick={onSendMessage} disabled={!currentMessage.trim() || isLoading}>
                Send
            </button>
        </div>
    )
}
